import React from "react";
import MasterLayout from "../masterLayout/MasterLayout";
import Breadcrumb from "../components/Breadcrumb";
import AmortizacaoLayer from "../components/AmortizacaoLayer";
import { useTranslation } from "../i18n/I18nContext";

const AmortizarPagamentoPage = () => {
  const { t } = useTranslation();
  return (
    <MasterLayout>
      <Breadcrumb title={t("propina.breadcrumb.amortize")} />
      <AmortizacaoLayer />
    </MasterLayout>
  );
};

export default AmortizarPagamentoPage;
